"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _RadioFilterModule = _interopRequireDefault(require("./RadioFilter.module.css"));
var _StyledFormControlLabel = require("./StyledFormControlLabel");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const allOption = {
  key: "all",
  label: "All"
};
const RadioFilter = _ref => {
  let {
    label,
    currentOption,
    options,
    onChange
  } = _ref;
  const changeHandler = (0, _react.useCallback)(event => {
    let option;
    if (event.target.value === allOption.key) {
      option = allOption;
    } else {
      option = options.find(option => option.key === event.target.value);
    }
    onChange(option);
  }, [onChange, options]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _RadioFilterModule.default["radio-filter"]
  }, /*#__PURE__*/_react.default.createElement("label", null, label), /*#__PURE__*/_react.default.createElement(_material.RadioGroup, {
    value: currentOption.key,
    onChange: changeHandler,
    row: true,
    name: "radio-buttons-group"
  }, options.map(option => /*#__PURE__*/_react.default.createElement(_StyledFormControlLabel.StyledFormControlLabel, {
    key: option.key,
    option: option
  })), /*#__PURE__*/_react.default.createElement(_StyledFormControlLabel.StyledFormControlLabel, {
    option: allOption
  })));
};
var _default = exports.default = RadioFilter;